import { Input, Button, Form } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { addOrificeSize, modifyOrificeSize } from "./orificeSizeSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";

export default function AddOrificeSize(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  const [orificesize_value, setorificesize_value] = React.useState("[1,2,3]");
  let pattern = /^\[[0-9]+([0-9,])+([0-9]])+$/;
  React.useEffect(() => {
    if (editBodySize?.id) {
      // if (editBodySize.user_role.toLowerCase() === "admin") {
      //     setRole("Admin")
      //     setIsRoleChecked(true)
      // } else {
      //     setRole("Contributor")
      //     setIsRoleChecked(false)
      // }
      form.setFieldsValue(editBodySize);
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    values.created_datetime = new Date().toLocaleString() + "";
    values.updated_datetime = "";
    if (editBodySize?.id) {
      //form type is edit
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyOrificeSize(values, editBodySize?.id));
      /* messageApi.open({
        type: "success",
        content: "Orifice Size updated successfully",
      }); */
    } else {
      dispatch(addOrificeSize(values));
     /*  messageApi.open({
        type: "success",
        content: "Orifice Size added successfully",
      }); */
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleOnChange = (e: any) => {
    setorificesize_value(e.target.value);
  };
  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Orifice Size"
        name="orificesize_value"
        rules={[
          {
            required: true,
            message: "Please enter orifice size",
          },
          {
            pattern: /^\[[0-9]+([0-9,])+([0-9]])+$/,
            message: "Please enter a valid orifice size, ex: [(0-9),(0-9),..]",
          },
        ]}
      >
        <Input id="orificesize_value" onChange={handleOnChange} />
      </Form.Item>

      <Form.Item>
        <Button
          disabled={pattern.test(orificesize_value) ? false : true}
          style={{
            backgroundColor: "#018B98",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          type="primary"
          htmlType="submit"
        >
          {editBodySize?.id ? "Update" : "Create"}
        </Button>
      </Form.Item>
    </Form>
  );
}
